import React from "react";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FeaturedImage, PublishDate, Excerpt, Body } from "newsItemHelpers";

import styles from "./ModalContent.scss";

const ModalContent = props => {
  let { modalNewsItem, settings } = props;

  // Set date format
  let _closeButton;
  switch (settings.lang.toLowerCase()) {
    case "fr":
      _closeButton = "Fermer";
      break;
    case "es":
      _closeButton = "Cerrar";
      break;
    default:
      _closeButton = "Close";
  }

  return (
    <article>
      <header className={`news-article-modal-header ${styles.header}`}>
        <h1 className={`news-article-modal-title ${styles.title}`}>
          {modalNewsItem.subjectTitle}
        </h1>
        <button
          className={`news-article-modal-close-btn ${styles.closeBtn}`}
          type="button"
          aria-label={_closeButton}
          onClick={props.handleCloseModal}
        >
          <FontAwesomeIcon className="fa-layers fa-fw" icon={faTimes} />
        </button>
      </header>
      <div className={`news-article-modal-content ${styles.content}`}>
        {settings.showModalImage &&
          modalNewsItem.featuredImageref &&
          modalNewsItem.featuredImageref.file &&
          modalNewsItem.featuredImageref.file.url && (
            <FeaturedImage
              data={modalNewsItem}
              fallbackImage={settings.fallbackImage}
              className={`news-article-modal-image ${styles.image}`}
            />
          )}
        <PublishDate
          date={modalNewsItem.postDate}
          lang={settings.lang}
          className={`news-article-modal__pubDate`}
        />
        {settings.showModalExcerpt && modalNewsItem.excerpt && (
          <Excerpt
            content={modalNewsItem.excerpt}
            className={`news-article-modal__excerpt`}
          />
        )}
        {modalNewsItem.body && (
          <Body
            content={modalNewsItem.body}
            className={`news-article-modal__body`}
          />
        )}
      </div>
    </article>
  );
};

export default ModalContent;
